import Logger from 'js-logger';

import config from '../constants/Config';

import TimeHelpers from '../utils/misc/TimeHelpers';
import LogicCore from '../logic/LogicCore';

const PreloaderState = function () {


};

PreloaderState.prototype = {

    constructor: PreloaderState,

    preload: function () {
        // need to track loading %
        this._pct = 0;

        // create preloader elements
        this._createVisualElements();

        // initial draw and mask position
        this.draw();

        //	Here we load the rest of the assets our game needs.
        //	+ lots of other required assets here

        // audio
        this.game.soundManager.loadSounds('assets/audio');

        // images
        this.game.load.image('skeeboard', require(`../../${config.imageSharedFolder}/backPlate_skee1024.png`));
        this.game.load.image('splash', require(`../../${config.imageSharedFolder}/splashSkee.png`));

        // atlases
        this.game.load.atlasJSONHash('skee',
            require(`../../${config.imageFolder}/skeeballPlay.png`),
            require(`file?name=data/[name].[hash].json!../../${config.imageFolder}/skeeballPlay.json`));

        // json data
        // hole meshes - use file loader because we just want a path, not the actual json
        this.game.load.json(LogicCore.HOLE_TAG_CENTER, require(`file?name=data/[name].json!../../${config.meshFolder}/centerCup.json`));
        this.game.load.json(LogicCore.HOLE_TAG_CENTER_UPPER, require(`file?name=data/[name].json!../../${config.meshFolder}/centerUpperCup.json`));
        this.game.load.json(LogicCore.HOLE_TAG_LARGE_CENTER, require(`file?name=data/[name].json!../../${config.meshFolder}/largeCenterCup.json`));
        this.game.load.json(LogicCore.HOLE_TAG_MIDDLE_TOP, require(`file?name=data/[name].json!../../${config.meshFolder}/middleTopCup.json`));
        this.game.load.json(LogicCore.HOLE_TAG_UPPER_LEFT, require(`file?name=data/[name].json!../../${config.meshFolder}/upperLeftCup.json`));
        this.game.load.json(LogicCore.HOLE_TAG_OUTER_RING, require(`file?name=data/[name].json!../../${config.meshFolder}/bigU.json`));
        // upper-right-cup is copied from upper-left

        // use fonts embedded in the main sheet- reduce load time & draw calls!
        this.game.load.xml('skeeFNT', require(`file?name=data/[name].xml!../../${config.fontFolder}/skeeFont.fnt`));
        this.game.load.xml('skeeBoldFNT', require(`file?name=data/[name].xml!../../${config.fontFolder}/skeeFontBold.fnt`));

        // listen for size changes
        this.scale.onSizeChange.add(this.draw, this);

    },

    loadUpdate: function () {

        // update load progress callback
        this._updateLoadBar(this.game.load.progress / 100);

    },

    create: function () {

        // create sounds
        this.game.soundManager.createSounds();

        // create bitmaps
        // ...

        // bitmap fonts
        this.game.cache.addBitmapFontByAtlas('skeefont', 'skee', 'skeeFont.png', this.game.cache.getXML('skeeFNT'));
        this.game.cache.addBitmapFontByAtlas('skeefontBold', 'skee', 'skeeFontBold.png', this.game.cache.getXML('skeeBoldFNT'));

        // TEST
        /*
        this._pct = 0;
        var pct = 0.1;
        setInterval(() => {
          if (pct <= 1.05)
          {
            this._updateLoadBar(pct);
            pct += 0.05;
          }

        }, 500)
        */

        // go to game
        this._exit();

    },

    update: function () {

    },

    shutdown: function () {

        this.scale.onSizeChange.remove(this.draw, this);

    },


    draw: function () {

        var centerX = this.game.width / 2;
        var centerY = this.game.height / 2;

        //this.loadingText.x = this.logo.x = this.loadingBar.x = centerX;
        this.loadingText.x = this.logo.x = centerX;

        // if lottery logo is present, shrink skeeball logo
        if (config.lottery !== 'demo') {
            this.lotteryLogo.x = centerX;
            this.lotteryLogo.y = centerY;

            this.logo.scale.set((this.game.height > 800) ? 0.8 : 0.7);

            // NOT USING IN MN
            //this.loadingBar.scale.set(this.logo.scale.y);

            this.logo.y = centerY - this.logo.height - 126;
            this.loadingText.y = this.lotteryLogo.y + this.lotteryLogo.height * 0.7;
            //this.loadingBar.y = this.logo.y + 237.5 * this.logo.scale.y;

        } else {
            this.logo.y = centerY - this.logo.height - 8;
            this.loadingText.y = this.logo.y + 300;
            //this.loadingBar.y = this.logo.y + 235;
        }

        //this.mask.x = this.loadingBar.x - this._maskWidth/2;
        //this.mask.y = this.loadingBar.y - this._maskHeight/2;

    },

    _updateLoadBar: function (pct) {

        // draw mask for bar
        this.game.add.tween(this).to({_pct: pct}, 300, Phaser.Easing.Cubic.Out, true).onUpdateCallback(this._drawMask, this);

    },

    _exit: function () {
        // go into GameState
        TimeHelpers.makeOneShotTimer(500, () => {
            setTimeout((function(group) {
                this.game.world.remove(group);
            }).bind(this, this.visualGroup), 500);

            this.game.state.start('GameState', false);
        });

    },

    _createVisualElements: function () {

        // fade group - hide at first to avoid jittery first draw
        this.visualGroup = this.game.add.group();
        this.visualGroup.alpha = 0;
        this.game.add.tween(this.visualGroup).to({alpha: 1}, 300, Phaser.Easing.Linear.None, true);

        // symbols
        //this.loadingBar = this.game.add.image(0, 0, 'loading', 'loadingBarColor.png', this.visualGroup);
        //this.loadingBar.anchor.set(0.5);

        this.loadingText = this.game.add.image(0, 0, 'loading', 'loadingText.png', this.visualGroup);
        this.loadingText.anchor.set(0.5, 0);

        this.logo = this.game.add.image(0, 0, 'loading', 'skeeLogoLoading.png', this.visualGroup);
        this.logo.anchor.set(0.5, 0);

        // add lottery logo in the middle
        this.lotteryLogo = this.game.add.image(0, 0, 'loading', config.lottery + 'L_logo1.png', this.visualGroup);
        this.lotteryLogo.anchor.set(0.5);
        this.lotteryLogo.visible = (config.lottery !== 'demo');

        // mask for loading bar
        //this._maskWidth = this.loadingBar.width+10;
        //this._maskHeight = this.loadingBar.height+10;

        //const mask = this.game.add.graphics(0, 0);
        //this.mask = mask;
        //this.loadingBar.mask = this.mask;
        this._drawMask(0);

    },

    _drawMask() {

        // NOT USING IN MN
        return;

        this.mask.beginFill(0x0000ff);
        this.mask.drawRect(0, 0, this._maskWidth * this._pct, this._maskHeight);
        this.mask.endFill();

    },


    /////////////////////////////////////////////////////////////////////////
    // SERVER INIT //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////
    _startLogic: function () {

        // tell logic to initialize the server connection
        this.game.logic.onSignalLogicInitialized.addOnce(this._handleLogicReady, this);
        this.game.logic.reset();

    },

    _handleLogicReady: function () {

        Logger.info('Logic ready...');

        // ready to go into the game now
        this._exit();

    }
};

export default PreloaderState;



// WEBPACK FOOTER //
// ./app/src/states/PreloaderState.js